import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
export var OrderInline;
(function (OrderInline) {
    OrderInline["DESC"] = "DESC";
    OrderInline["ASC"] = "ASC";
})(OrderInline || (OrderInline = {}));
export var SortInline;
(function (SortInline) {
    SortInline["createdAt"] = "createdAt";
    SortInline["message"] = "message";
})(SortInline || (SortInline = {}));
export const getNotPaidCreditCardCampaignsCount = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/campaigns/credit-cards/notPaid/count';
    const pathInternal = '/api/campaigns/credit-cards/notPaid/count';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getNotPaidCreditCardCampaignsCount.paramsOrder = [];
export const getCampaignStatuses = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/campaigns/statuses';
    const pathInternal = '/api/campaigns/statuses';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignStatuses.paramsOrder = [];
export const getStages = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/campaigns/stages';
    const pathInternal = '/api/campaigns/stages';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getStages.paramsOrder = [];
export const getReportingTypes = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/campaigns/reporting-types';
    const pathInternal = '/api/campaigns/reporting-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingTypes.paramsOrder = [];
export const getCampaignPdfStyleConfig = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/pdf-style-config'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/pdf-style-config'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPdfStyleConfig.paramsOrder = [{ type: 'parameters' }];
export const getCampaignsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.ids === undefined) {
        throw new Error('Missing required body: ids');
    }
    const path = '/api/ws-orders/campaigns/byIds';
    const pathInternal = '/api/campaigns/byIds';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.ids !== undefined) {
        body = params.ids;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignsByIds.paramsOrder = [{ type: 'body', paramName: 'ids' }];
/** Returns a campaign with campaign positions. */ export const findByCampaignIdAndAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/detail-by-accounts/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/detail-by-accounts/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findByCampaignIdAndAccounts.paramsOrder = [{ type: 'parameters' }];
/** Returns a campaign. */ export const findByCampaignId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findByCampaignId.paramsOrder = [{ type: 'parameters' }];
/** Returns a campaign. */ export const updateCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaign === undefined) {
        throw new Error('Missing required body: campaign');
    }
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaign !== undefined) {
        body = params.campaign;
    }
    {
        const value = queryDefaults === false
            ? params.createdAdvertiserId
            : (params.createdAdvertiserId ?? queryDefaults?.['createdAdvertiserId']);
        if (value !== undefined) {
            urlParams.append('createdAdvertiserId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaign.paramsOrder = [{ type: 'body', paramName: 'campaign' }, { type: 'parameters' }];
/** Returns a campaign. */ export const updateCampaignStage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaign === undefined) {
        throw new Error('Missing required body: campaign');
    }
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/stage'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/stage'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaign !== undefined) {
        body = params.campaign;
    }
    {
        const value = queryDefaults === false
            ? params.isCreditCardPayment
            : (params.isCreditCardPayment ?? queryDefaults?.['isCreditCardPayment']);
        if (value !== undefined) {
            urlParams.append('isCreditCardPayment', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaignStage.paramsOrder = [{ type: 'body', paramName: 'campaign' }, { type: 'parameters' }];
/** Returns a campaign. */ export const updateCampaignCardPaymentInfo = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.isPaid === undefined) {
        throw new Error('Missing required parameter: isPaid');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/card-payment-info'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/card-payment-info'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.isPaid !== undefined) {
        urlParams.append('isPaid', params.isPaid.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaignCardPaymentInfo.paramsOrder = [{ type: 'parameters' }];
/** Returns a campaign. */ export const updateCampaignSalesPromotion = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/sales-promotion'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/sales-promotion'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaignSalesPromotion.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns a campaign. */ export const activateSelfBookedCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/activate-self-booked'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/activate-self-booked'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    {
        const value = queryDefaults === false
            ? params.isCreditCardPayment
            : (params.isCreditCardPayment ?? queryDefaults?.['isCreditCardPayment']);
        if (value !== undefined) {
            urlParams.append('isCreditCardPayment', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
activateSelfBookedCampaign.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const recalculateCampaignNumbersForDigital = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.digitalPositions === undefined) {
        throw new Error('Missing required body: digitalPositions');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/recalculate-digital-numbers'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/recalculate-digital-numbers'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.digitalPositions !== undefined) {
        body = params.digitalPositions;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
recalculateCampaignNumbersForDigital.paramsOrder = [
    { type: 'body', paramName: 'digitalPositions' },
    { type: 'parameters' },
];
export const recalculateCampaignNumbersForPrint = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.printPositions === undefined) {
        throw new Error('Missing required body: printPositions');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/recalculate-print-numbers'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/recalculate-print-numbers'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.printPositions !== undefined) {
        body = params.printPositions;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
recalculateCampaignNumbersForPrint.paramsOrder = [
    { type: 'body', paramName: 'printPositions' },
    { type: 'parameters' },
];
export const recalculateCampaignNumbersForConsulting = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.consultingPositions === undefined) {
        throw new Error('Missing required body: consultingPositions');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/recalculate-consulting-numbers'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/recalculate-consulting-numbers'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.consultingPositions !== undefined) {
        body = params.consultingPositions;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
recalculateCampaignNumbersForConsulting.paramsOrder = [
    { type: 'body', paramName: 'consultingPositions' },
    { type: 'parameters' },
];
export const recalculateCampaignNumbersForBroadcast = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.campaignPositionType === undefined) {
        throw new Error('Missing required parameter: campaignPositionType');
    }
    if (params.broadcastPositions === undefined) {
        throw new Error('Missing required body: broadcastPositions');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/recalculate-broadcast-numbers'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/recalculate-broadcast-numbers'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionType !== undefined) {
        urlParams.append('campaignPositionType', params.campaignPositionType.toString());
    }
    if (params.broadcastPositions !== undefined) {
        body = params.broadcastPositions;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
recalculateCampaignNumbersForBroadcast.paramsOrder = [
    { type: 'body', paramName: 'broadcastPositions' },
    { type: 'parameters' },
];
export const recalculateCampaignNumbersForPointOfSale = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.pointOfSalePositions === undefined) {
        throw new Error('Missing required body: pointOfSalePositions');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/recalculate-point-of-sale-numbers'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/recalculate-point-of-sale-numbers'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.pointOfSalePositions !== undefined) {
        body = params.pointOfSalePositions;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
recalculateCampaignNumbersForPointOfSale.paramsOrder = [
    { type: 'body', paramName: 'pointOfSalePositions' },
    { type: 'parameters' },
];
export const recalculateCampaignNumbersForPostnetzAnalog = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.analogPositions === undefined) {
        throw new Error('Missing required body: analogPositions');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/recalculate-postnetz-analog-numbers'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/recalculate-postnetz-analog-numbers'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.analogPositions !== undefined) {
        body = params.analogPositions;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
recalculateCampaignNumbersForPostnetzAnalog.paramsOrder = [
    { type: 'body', paramName: 'analogPositions' },
    { type: 'parameters' },
];
export const recalculateCampaignDeliveryData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.digitalPositions === undefined) {
        throw new Error('Missing required body: digitalPositions');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/recalculate-campaign-delivery-data'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/recalculate-campaign-delivery-data'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.digitalPositions !== undefined) {
        body = params.digitalPositions;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
recalculateCampaignDeliveryData.paramsOrder = [
    { type: 'body', paramName: 'digitalPositions' },
    { type: 'parameters' },
];
/** Change campaign status */ export const changeCampaignStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.statusName === undefined) {
        throw new Error('Missing required parameter: statusName');
    }
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/change-campaign-status'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/change-campaign-status'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.statusName !== undefined) {
        urlParams.append('statusName', params.statusName.toString());
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
changeCampaignStatus.paramsOrder = [{ type: 'parameters' }];
/** Update booked stage */ export const updateBookedStage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/update-booked-stage'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/update-booked-stage'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updateBookedStage.paramsOrder = [{ type: 'parameters' }];
/** Update invoice state */ export const updatePrepaymentStage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.invoiceState === undefined) {
        throw new Error('Missing required parameter: invoiceState');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/update-prepayment-stage'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/update-prepayment-stage'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.invoiceState !== undefined) {
        urlParams.append('invoiceState', params.invoiceState.toString());
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
updatePrepaymentStage.paramsOrder = [{ type: 'parameters' }];
/** Update campaign state in SF */ export const cloneCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/clone'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/clone'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.stage : (params.stage ?? queryDefaults?.['stage']);
        if (value !== undefined) {
            urlParams.append('stage', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.shouldFetchActualCommission
            : (params.shouldFetchActualCommission ?? queryDefaults?.['shouldFetchActualCommission']);
        if (value !== undefined) {
            urlParams.append('shouldFetchActualCommission', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.manualStartDate : (params.manualStartDate ?? queryDefaults?.['manualStartDate']);
        if (value !== undefined) {
            urlParams.append('manualStartDate', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.manualEndDate : (params.manualEndDate ?? queryDefaults?.['manualEndDate']);
        if (value !== undefined) {
            urlParams.append('manualEndDate', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.updateAccountSettings
            : (params.updateAccountSettings ?? queryDefaults?.['updateAccountSettings']);
        if (value !== undefined) {
            urlParams.append('updateAccountSettings', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneCampaign.paramsOrder = [{ type: 'parameters' }];
/** Check campaign and it's positions before cloning */ export const checkBeforeClone = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/clone/check'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/clone/check'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
checkBeforeClone.paramsOrder = [{ type: 'parameters' }];
/** Creates campaign. */ export const createCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaign === undefined) {
        throw new Error('Missing required body: campaign');
    }
    const path = '/api/ws-orders/campaigns';
    const pathInternal = '/api/campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaign !== undefined) {
        body = params.campaign;
    }
    {
        const value = queryDefaults === false
            ? params.createdAdvertiserId
            : (params.createdAdvertiserId ?? queryDefaults?.['createdAdvertiserId']);
        if (value !== undefined) {
            urlParams.append('createdAdvertiserId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCampaign.paramsOrder = [{ type: 'body', paramName: 'campaign' }, { type: 'parameters' }];
/** Returns a campaign with campaign positions. */ export const findByCampaignIdCheckRole = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/detail/{campaignId}/check-role/support-sf'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/detail/{campaignId}/check-role/support-sf'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findByCampaignIdCheckRole.paramsOrder = [{ type: 'parameters' }];
/** Returns list SF IDs of campaigns by account list */ export const parseCampaignIdList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountIdList === undefined) {
        throw new Error('Missing required body: accountIdList');
    }
    const path = '/api/ws-orders/campaigns/ids';
    const pathInternal = '/api/campaigns/ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountIdList !== undefined) {
        body = params.accountIdList;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
parseCampaignIdList.paramsOrder = [{ type: 'body', paramName: 'accountIdList' }];
/** Returns a campaign template for advertiser. */ export const buildCampaignTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.advertiserId === undefined) {
        throw new Error('Missing required parameter: advertiserId');
    }
    const path = '/api/ws-orders/campaigns/template';
    const pathInternal = '/api/campaigns/template';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.advertiserId !== undefined) {
        urlParams.append('advertiserId', params.advertiserId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
buildCampaignTemplate.paramsOrder = [{ type: 'parameters' }];
/** Returns campaign */ export const getBatchCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-orders/batch/campaigns';
    const pathInternal = '/api/batch/campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchCampaigns.paramsOrder = [{ type: 'parameters' }];
/** Returns campaigns for reporting */ export const getReportingCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-orders/reporting/campaigns';
    const pathInternal = '/api/reporting/campaigns';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingCampaigns.paramsOrder = [{ type: 'parameters' }];
/** Returns campaigns for reporting using keyset pagination */ export const getReportingCampaignsCursor = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.lastId === undefined) {
        throw new Error('Missing required parameter: lastId');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-orders/reporting/campaigns/cursor';
    const pathInternal = '/api/reporting/campaigns/cursor';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lastId !== undefined) {
        urlParams.append('lastId', params.lastId.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingCampaignsCursor.paramsOrder = [{ type: 'parameters' }];
/** Returns campaign positions of all types for reporting using keyset pagination */ export const getReportingCampaignPositionsCursor = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.lastId === undefined) {
        throw new Error('Missing required parameter: lastId');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-orders/reporting/campaign-positions/cursor';
    const pathInternal = '/api/reporting/campaign-positions/cursor';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.lastId !== undefined) {
        urlParams.append('lastId', params.lastId.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getReportingCampaignPositionsCursor.paramsOrder = [{ type: 'parameters' }];
/** Returns credit card payment campaigns */ export const getBatchCreditCardCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-orders/batch/campaigns/credit-card';
    const pathInternal = '/api/batch/campaigns/credit-card';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchCreditCardCampaigns.paramsOrder = [{ type: 'parameters' }];
/** Returns campaign with screenshots */ export const getBatchScreenshotCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-orders/batch/campaigns/with-screenshots';
    const pathInternal = '/api/batch/campaigns/with-screenshots';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchScreenshotCampaigns.paramsOrder = [{ type: 'parameters' }];
/** Returns campaign by type */ export const getBatchCampaignsByTypeForOps = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-orders/batch/campaigns/by-stage';
    const pathInternal = '/api/batch/campaigns/by-stage';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    {
        const value = queryDefaults === false ? params.stage : (params.stage ?? queryDefaults?.['stage']);
        if (value !== undefined) {
            urlParams.append('stage', value.toString());
        }
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchCampaignsByTypeForOps.paramsOrder = [{ type: 'parameters' }];
export const createOrUpdateSspCampaign = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaign === undefined) {
        throw new Error('Missing required body: campaign');
    }
    const path = '/api/ws-orders/ssp/campaign';
    const pathInternal = '/api/ssp/campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaign !== undefined) {
        body = params.campaign;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createOrUpdateSspCampaign.paramsOrder = [{ type: 'body', paramName: 'campaign' }];
/** Deletes ssp campaigns */ export const deleteSspCampaignByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignIdsToDelete === undefined) {
        throw new Error('Missing required body: campaignIdsToDelete');
    }
    const path = '/api/ws-orders/ssp/campaign';
    const pathInternal = '/api/ssp/campaign';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignIdsToDelete !== undefined) {
        body = params.campaignIdsToDelete;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteSspCampaignByIds.paramsOrder = [{ type: 'body', paramName: 'campaignIdsToDelete' }];
/** List of filtered campaigns */ export const getFilteredCampaigns = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.filter === undefined) {
        throw new Error('Missing required body: filter');
    }
    const path = '/api/ws-orders/campaigns/get';
    const pathInternal = '/api/campaigns/get';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        body = params.filter;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getFilteredCampaigns.paramsOrder = [{ type: 'body', paramName: 'filter' }];
/** Returns a campaign counter. */ export const getCampaignsCounter = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-orders/campaigns/counters';
    const pathInternal = '/api/campaigns/counters';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignsCounter.paramsOrder = [{ type: 'parameters' }];
/** Agency dashboard links */ export const getAgencyDashboardLinks = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/accounts/links';
    const pathInternal = '/api/accounts/links';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAgencyDashboardLinks.paramsOrder = [];
export const calculateServiceDashboardStatistics = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/accounts/dashboard/statistics';
    const pathInternal = '/api/accounts/dashboard/statistics';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
calculateServiceDashboardStatistics.paramsOrder = [{ type: 'parameters' }];
/** Returns all accounts */ export const getAccounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/accounts';
    const pathInternal = '/api/accounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.prefix : (params.prefix ?? queryDefaults?.['prefix']);
        if (value !== undefined) {
            urlParams.append('prefix', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.role : (params.role ?? queryDefaults?.['role']);
        if (value !== undefined) {
            urlParams.append('role', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccounts.paramsOrder = [{ type: 'parameters' }];
/** Returns an account by ID */ export const getAccountByIdShort = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-orders/accounts/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/accounts/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAccountByIdShort.paramsOrder = [{ type: 'parameters' }];
/** Replace old account id with new one. */ export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-orders/accounts/replace-account-id';
    const pathInternal = '/api/accounts/replace-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
/** Replace old post account id with new one. */ export const replacePostAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.postAccountId === undefined) {
        throw new Error('Missing required parameter: postAccountId');
    }
    if (params.newPostAccountId === undefined) {
        throw new Error('Missing required parameter: newPostAccountId');
    }
    const path = '/api/ws-orders/accounts/replace-post-account-id';
    const pathInternal = '/api/accounts/replace-post-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.postAccountId !== undefined) {
        urlParams.append('postAccountId', params.postAccountId.toString());
    }
    if (params.newPostAccountId !== undefined) {
        urlParams.append('newPostAccountId', params.newPostAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replacePostAccountId.paramsOrder = [{ type: 'parameters' }];
export const getDocuments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/documents';
    const pathInternal = '/api/documents';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.entityType : (params.entityType ?? queryDefaults?.['entityType']);
        if (value !== undefined) {
            urlParams.append('entityType', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.entityId : (params.entityId ?? queryDefaults?.['entityId']);
        if (value !== undefined) {
            urlParams.append('entityId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.documentCategory
            : (params.documentCategory ?? queryDefaults?.['documentCategory']);
        if (value !== undefined) {
            urlParams.append('documentCategory', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDocuments.paramsOrder = [{ type: 'parameters' }];
export const getDocumentsCountByCategories = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/documents/count';
    const pathInternal = '/api/documents/count';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.entityType : (params.entityType ?? queryDefaults?.['entityType']);
        if (value !== undefined) {
            urlParams.append('entityType', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.entityId : (params.entityId ?? queryDefaults?.['entityId']);
        if (value !== undefined) {
            urlParams.append('entityId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getDocumentsCountByCategories.paramsOrder = [{ type: 'parameters' }];
/** Creates new document and it's ref to file-uploader. */ export const createDocumentFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.body === undefined) {
        throw new Error('Missing required body: body');
    }
    const path = '/api/ws-orders/documents/create';
    const pathInternal = '/api/documents/create';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createDocumentFile.paramsOrder = [{ type: 'body', paramName: 'body' }];
/** Rename document */ export const renameDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.name === undefined) {
        throw new Error('Missing required parameter: name');
    }
    const path = '/api/ws-orders/documents/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/documents/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.name !== undefined) {
        urlParams.append('name', params.name.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
renameDocument.paramsOrder = [{ type: 'parameters' }];
/** Marks selected document as deleted */ export const deleteDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-orders/documents/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/documents/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
deleteDocument.paramsOrder = [{ type: 'parameters' }];
/** Returns the Attachment in Base64 format. */ export const downloadDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-orders/documents/{id}/download'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/documents/{id}/download'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
downloadDocument.paramsOrder = [{ type: 'parameters' }];
/** Returns paginated list of pricelists */ export const getPaginatedPriceList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/price-lists/paginated';
    const pathInternal = '/api/price-lists/paginated';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPaginatedPriceList.paramsOrder = [{ type: 'parameters' }];
/** Returns list of pricelists */ export const getPriceLists = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/price-lists';
    const pathInternal = '/api/price-lists';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPriceLists.paramsOrder = [{ type: 'parameters' }];
/** PriceList creation */ export const createPriceList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.priceList === undefined) {
        throw new Error('Missing required body: priceList');
    }
    const path = '/api/ws-orders/price-lists';
    const pathInternal = '/api/price-lists';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.priceList !== undefined) {
        body = params.priceList;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createPriceList.paramsOrder = [{ type: 'body', paramName: 'priceList' }];
/** get price list by id */ export const getPriceListById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-orders/price-lists/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/price-lists/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPriceListById.paramsOrder = [{ type: 'parameters' }];
/** Updates priceList */ export const updatePriceList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-orders/price-lists/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/price-lists/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePriceList.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Set price list active state */ export const setPriceListActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-orders/price-lists/{id}/active/{active}'
        .replace('{id}', params.id?.toString())
        .replace('{active}', params.active?.toString());
    const pathInternal = '/api/price-lists/{id}/active/{active}'
        .replace('{id}', params.id?.toString())
        .replace('{active}', params.active?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setPriceListActive.paramsOrder = [{ type: 'parameters' }];
/** sync price list with the one by provided company */ export const syncPriceLists = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.originalPriceListId === undefined) {
        throw new Error('Missing required parameter: originalPriceListId');
    }
    if (params.toCompanyId === undefined) {
        throw new Error('Missing required parameter: toCompanyId');
    }
    const path = '/api/ws-orders/price-lists/sync';
    const pathInternal = '/api/price-lists/sync';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.originalPriceListId !== undefined) {
        urlParams.append('originalPriceListId', params.originalPriceListId.toString());
    }
    if (params.toCompanyId !== undefined) {
        urlParams.append('toCompanyId', params.toCompanyId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
syncPriceLists.paramsOrder = [{ type: 'parameters' }];
/** Count active campaigns by campaign position ids */ export const countActiveCampaignsByCampaignPositionIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-orders/campaign/campaign-position/count-active';
    const pathInternal = '/api/campaign/campaign-position/count-active';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Accept'] = 'text/plain';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
countActiveCampaignsByCampaignPositionIds.paramsOrder = [{ type: 'body', paramName: 'campaignPositionIds' }];
/** Returns preview html. */ export const getHtmlAttachmentPreview = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/attachment/html'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/attachment/html'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.countryCode : (params.countryCode ?? queryDefaults?.['countryCode']);
        if (value !== undefined) {
            urlParams.append('countryCode', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.orientationType : (params.orientationType ?? queryDefaults?.['orientationType']);
        if (value !== undefined) {
            urlParams.append('orientationType', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.onlyData : (params.onlyData ?? queryDefaults?.['onlyData']);
        if (value !== undefined) {
            urlParams.append('onlyData', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'text/html';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getHtmlAttachmentPreview.paramsOrder = [{ type: 'parameters' }];
/** Recalculate campaign`s delivery numbers. */ export const campaignExistsByLabelId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.labelId === undefined) {
        throw new Error('Missing required parameter: labelId');
    }
    const path = '/api/ws-orders/campaigns/exists-by-label-id';
    const pathInternal = '/api/campaigns/exists-by-label-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.labelId !== undefined) {
        urlParams.append('labelId', params.labelId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
campaignExistsByLabelId.paramsOrder = [{ type: 'parameters' }];
/** Check if user permitted to edit campaign */ export const checkCampaignEditingPermission = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/check-editing-permission'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/check-editing-permission'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
checkCampaignEditingPermission.paramsOrder = [{ type: 'parameters' }];
/** Calculate financial data */ export const calculateCampaignPositionData = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.body === undefined) {
        throw new Error('Missing required body: body');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/campaign-positions/calculate'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/campaign-positions/calculate'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
calculateCampaignPositionData.paramsOrder = [{ type: 'body', paramName: 'body' }, { type: 'parameters' }];
/** Calculate financial data */ export const calculateCampaignPositionDataList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.body === undefined) {
        throw new Error('Missing required body: body');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/campaign-positions/calculate-list'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/campaign-positions/calculate-list'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
calculateCampaignPositionDataList.paramsOrder = [{ type: 'body', paramName: 'body' }, { type: 'parameters' }];
/** Calculate discounts for the Campaign Position based on default account discounts and per ad media (if present) */ export const calculateCampaignPositionDiscounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.discountsForm === undefined) {
        throw new Error('Missing required body: discountsForm');
    }
    const path = '/api/ws-orders/campaign-positions/calculate-discounts';
    const pathInternal = '/api/campaign-positions/calculate-discounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.discountsForm !== undefined) {
        body = params.discountsForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
calculateCampaignPositionDiscounts.paramsOrder = [{ type: 'body', paramName: 'discountsForm' }];
/** Returns all campaign positions by campaign id. */ export const findAllCampaignPositionsByCampaignId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaign-positions/by-campaign/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaign-positions/by-campaign/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findAllCampaignPositionsByCampaignId.paramsOrder = [{ type: 'parameters' }];
/** Returns a campaign position by id. */ export const findCampaignPositionById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-orders/campaign-positions/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/campaign-positions/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findCampaignPositionById.paramsOrder = [{ type: 'parameters' }];
/** Get list of discounts of the campaign positions */ export const getCampaignPositionDiscountsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.body === undefined) {
        throw new Error('Missing required body: body');
    }
    const path = '/api/ws-orders/campaign-positions/discounts/by-ids';
    const pathInternal = '/api/campaign-positions/discounts/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionDiscountsByIds.paramsOrder = [{ type: 'body', paramName: 'body' }];
/** upload csv data with campaign positions */ export const importCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.importId === undefined) {
        throw new Error('Missing required parameter: importId');
    }
    const path = '/api/ws-orders/import/campaign-position';
    const pathInternal = '/api/import/campaign-position';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    if (params.importId !== undefined) {
        urlParams.append('importId', params.importId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
importCampaignPositions.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
export const getCampaignPositionImportTemplate = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/import/campaign-position/template';
    const pathInternal = '/api/import/campaign-position/template';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
getCampaignPositionImportTemplate.paramsOrder = [];
/** Reserves campaign positions ids for future use */ export const reserveCampaignPositionIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.idsCount === undefined) {
        throw new Error('Missing required parameter: idsCount');
    }
    const path = '/api/ws-orders/campaign-positions/reserve-ids';
    const pathInternal = '/api/campaign-positions/reserve-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.idsCount !== undefined) {
        urlParams.append('idsCount', params.idsCount.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
reserveCampaignPositionIds.paramsOrder = [{ type: 'parameters' }];
/** Returns batch campaign positions */ export const getBatchCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-orders/batch/campaign-positions';
    const pathInternal = '/api/batch/campaign-positions';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchCampaignPositions.paramsOrder = [{ type: 'parameters' }];
/** Returns created document for campaign. */ export const createAttachmentDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.documentExtension === undefined) {
        throw new Error('Missing required parameter: documentExtension');
    }
    const path = '/api/ws-orders/documents/{campaignId}/attachment'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/documents/{campaignId}/attachment'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.documentExtension !== undefined) {
        urlParams.append('documentExtension', params.documentExtension.toString());
    }
    {
        const value = queryDefaults === false ? params.orientationType : (params.orientationType ?? queryDefaults?.['orientationType']);
        if (value !== undefined) {
            urlParams.append('orientationType', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.language : (params.language ?? queryDefaults?.['language']);
        if (value !== undefined) {
            urlParams.append('language', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createAttachmentDocument.paramsOrder = [{ type: 'parameters' }];
/** Send campaign offer/order pdf to user */ export const sendCampaignDocument = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.sendCampaignPdfForm === undefined) {
        throw new Error('Missing required body: sendCampaignPdfForm');
    }
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/documents/{campaignId}/send'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/documents/{campaignId}/send'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.sendCampaignPdfForm !== undefined) {
        body = params.sendCampaignPdfForm;
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
sendCampaignDocument.paramsOrder = [
    { type: 'body', paramName: 'sendCampaignPdfForm' },
    { type: 'parameters' },
];
/** Calculate discounts for the Campaign based on default account discounts */ export const calculateCampaignDiscounts = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.discountsForm === undefined) {
        throw new Error('Missing required body: discountsForm');
    }
    const path = '/api/ws-orders/campaigns/calculate-discounts';
    const pathInternal = '/api/campaigns/calculate-discounts';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.discountsForm !== undefined) {
        body = params.discountsForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
calculateCampaignDiscounts.paramsOrder = [{ type: 'body', paramName: 'discountsForm' }];
export const getCampaignTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/campaigns/types';
    const pathInternal = '/api/campaigns/types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.campaignId : (params.campaignId ?? queryDefaults?.['campaignId']);
        if (value !== undefined) {
            urlParams.append('campaignId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignTypes.paramsOrder = [{ type: 'parameters' }];
export const createCampaignType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignType === undefined) {
        throw new Error('Missing required body: campaignType');
    }
    const path = '/api/ws-orders/campaigns/types';
    const pathInternal = '/api/campaigns/types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignType !== undefined) {
        body = params.campaignType;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCampaignType.paramsOrder = [{ type: 'body', paramName: 'campaignType' }];
export const getCampaignType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.typeId === undefined) {
        throw new Error('Missing required parameter: typeId');
    }
    const path = '/api/ws-orders/campaign-types/{typeId}'.replace('{typeId}', params.typeId?.toString());
    const pathInternal = '/api/campaign-types/{typeId}'.replace('{typeId}', params.typeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignType.paramsOrder = [{ type: 'parameters' }];
export const updateCampaignType = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignType === undefined) {
        throw new Error('Missing required body: campaignType');
    }
    if (params.typeId === undefined) {
        throw new Error('Missing required parameter: typeId');
    }
    const path = '/api/ws-orders/campaign-types/{typeId}'.replace('{typeId}', params.typeId?.toString());
    const pathInternal = '/api/campaign-types/{typeId}'.replace('{typeId}', params.typeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignType !== undefined) {
        body = params.campaignType;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaignType.paramsOrder = [{ type: 'body', paramName: 'campaignType' }, { type: 'parameters' }];
export const getCampaignTypeMailTemplateWarning = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.typeId === undefined) {
        throw new Error('Missing required parameter: typeId');
    }
    if (params.salesUnitId === undefined) {
        throw new Error('Missing required parameter: salesUnitId');
    }
    const path = '/api/ws-orders/campaign-types/{typeId}/mail-template-warning'.replace('{typeId}', params.typeId?.toString());
    const pathInternal = '/api/campaign-types/{typeId}/mail-template-warning'.replace('{typeId}', params.typeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.salesUnitId !== undefined) {
        urlParams.append('salesUnitId', params.salesUnitId.toString());
    }
    const headers = {};
    headers['Accept'] = 'text/plain';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'text',
        requestType: 'json',
    });
};
getCampaignTypeMailTemplateWarning.paramsOrder = [{ type: 'parameters' }];
export const updateCampaignTypesSortOrder = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignTypeWithSortOrderForm === undefined) {
        throw new Error('Missing required body: campaignTypeWithSortOrderForm');
    }
    const path = '/api/ws-orders/campaigns/types/sort-orders';
    const pathInternal = '/api/campaigns/types/sort-orders';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignTypeWithSortOrderForm !== undefined) {
        body = params.campaignTypeWithSortOrderForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCampaignTypesSortOrder.paramsOrder = [{ type: 'body', paramName: 'campaignTypeWithSortOrderForm' }];
export const getBatchCampaignTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-orders/campaigns/types/batch';
    const pathInternal = '/api/campaigns/types/batch';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchCampaignTypes.paramsOrder = [{ type: 'parameters' }];
export const getBatchPriceLists = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-orders/price-lists/batch';
    const pathInternal = '/api/price-lists/batch';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchPriceLists.paramsOrder = [{ type: 'parameters' }];
export const getBatchPositionGroups = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-orders/position-groups/batch';
    const pathInternal = '/api/position-groups/batch';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchPositionGroups.paramsOrder = [{ type: 'parameters' }];
/** Get all position groups */ export const getPositionGroups = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.filter === undefined) {
        throw new Error('Missing required body: filter');
    }
    const path = '/api/ws-orders/position-groups/get';
    const pathInternal = '/api/position-groups/get';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.filter !== undefined) {
        body = params.filter;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPositionGroups.paramsOrder = [{ type: 'body', paramName: 'filter' }];
/** Calculate amount gross 1 */ export const calculateCampaignPositionGroupAmountGross1 = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.body === undefined) {
        throw new Error('Missing required body: body');
    }
    const path = '/api/ws-orders/position-groups/gross1/calculate';
    const pathInternal = '/api/position-groups/gross1/calculate';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
calculateCampaignPositionGroupAmountGross1.paramsOrder = [{ type: 'body', paramName: 'body' }];
/** Create position group */ export const createPositionGroup = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.positionGroupForm === undefined) {
        throw new Error('Missing required body: positionGroupForm');
    }
    const path = '/api/ws-orders/position-groups';
    const pathInternal = '/api/position-groups';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.positionGroupForm !== undefined) {
        body = params.positionGroupForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createPositionGroup.paramsOrder = [{ type: 'body', paramName: 'positionGroupForm' }];
/** Get single position group */ export const getPositionGroupById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.positionGroupId === undefined) {
        throw new Error('Missing required parameter: positionGroupId');
    }
    const path = '/api/ws-orders/position-groups/{positionGroupId}'.replace('{positionGroupId}', params.positionGroupId?.toString());
    const pathInternal = '/api/position-groups/{positionGroupId}'.replace('{positionGroupId}', params.positionGroupId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPositionGroupById.paramsOrder = [{ type: 'parameters' }];
/** Update position group */ export const updatePositionGroup = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.positionGroupId === undefined) {
        throw new Error('Missing required parameter: positionGroupId');
    }
    if (params.positionGroupForm === undefined) {
        throw new Error('Missing required body: positionGroupForm');
    }
    const path = '/api/ws-orders/position-groups/{positionGroupId}'.replace('{positionGroupId}', params.positionGroupId?.toString());
    const pathInternal = '/api/position-groups/{positionGroupId}'.replace('{positionGroupId}', params.positionGroupId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.positionGroupForm !== undefined) {
        body = params.positionGroupForm;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePositionGroup.paramsOrder = [{ type: 'body', paramName: 'positionGroupForm' }, { type: 'parameters' }];
/** Set PositionGroup active state */ export const setPositionGroupActive = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.positionGroupId === undefined) {
        throw new Error('Missing required parameter: positionGroupId');
    }
    if (params.active === undefined) {
        throw new Error('Missing required parameter: active');
    }
    const path = '/api/ws-orders/position-groups/{positionGroupId}/active/{active}'
        .replace('{positionGroupId}', params.positionGroupId?.toString())
        .replace('{active}', params.active?.toString());
    const pathInternal = '/api/position-groups/{positionGroupId}/active/{active}'
        .replace('{positionGroupId}', params.positionGroupId?.toString())
        .replace('{active}', params.active?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
setPositionGroupActive.paramsOrder = [{ type: 'parameters' }];
/** Update entries on position group */ export const updatePositionGroupEntries = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.body === undefined) {
        throw new Error('Missing required body: body');
    }
    if (params.positionGroupId === undefined) {
        throw new Error('Missing required parameter: positionGroupId');
    }
    const path = '/api/ws-orders/position-groups/{positionGroupId}/entries'.replace('{positionGroupId}', params.positionGroupId?.toString());
    const pathInternal = '/api/position-groups/{positionGroupId}/entries'.replace('{positionGroupId}', params.positionGroupId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.body !== undefined) {
        body = params.body;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updatePositionGroupEntries.paramsOrder = [{ type: 'body', paramName: 'body' }, { type: 'parameters' }];
/** Get position groups */ export const getPositionGroupsByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.positionGroupIds === undefined) {
        throw new Error('Missing required body: positionGroupIds');
    }
    const path = '/api/ws-orders/position-groups/by-ids';
    const pathInternal = '/api/position-groups/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.positionGroupIds !== undefined) {
        body = params.positionGroupIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPositionGroupsByIds.paramsOrder = [{ type: 'body', paramName: 'positionGroupIds' }];
/** Get position groups */ export const getPositionGroupNamesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.positionGroupIds === undefined) {
        throw new Error('Missing required body: positionGroupIds');
    }
    const path = '/api/ws-orders/position-group-names/by-ids';
    const pathInternal = '/api/position-group-names/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.positionGroupIds !== undefined) {
        body = params.positionGroupIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPositionGroupNamesByIds.paramsOrder = [{ type: 'body', paramName: 'positionGroupIds' }];
/** Returns a list of users created a campaign */ export const getCreatedByUsers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.type === undefined) {
        throw new Error('Missing required parameter: type');
    }
    const path = '/api/ws-orders/created-by-users';
    const pathInternal = '/api/created-by-users';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.type !== undefined) {
        urlParams.append('type', params.type.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreatedByUsers.paramsOrder = [{ type: 'parameters' }];
export const getOwnerList = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-orders/owners';
    const pathInternal = '/api/owners';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.prefix : (params.prefix ?? queryDefaults?.['prefix']);
        if (value !== undefined) {
            urlParams.append('prefix', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getOwnerList.paramsOrder = [{ type: 'parameters' }];
export const getPersonalComments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.showRead === undefined) {
        throw new Error('Missing required parameter: showRead');
    }
    const path = '/api/ws-orders/comments/me';
    const pathInternal = '/api/comments/me';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.showRead !== undefined) {
        urlParams.append('showRead', params.showRead.toString());
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateFrom : (params.dateFrom ?? queryDefaults?.['dateFrom']);
        if (value !== undefined) {
            urlParams.append('dateFrom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.dateTo : (params.dateTo ?? queryDefaults?.['dateTo']);
        if (value !== undefined) {
            urlParams.append('dateTo', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPersonalComments.paramsOrder = [{ type: 'parameters' }];
/** Returns comments */ export const getComments = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/comments';
    const pathInternal = '/api/comments';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getComments.paramsOrder = [{ type: 'parameters' }];
/** Create comment */ export const createComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.comment === undefined) {
        throw new Error('Missing required body: comment');
    }
    const path = '/api/ws-orders/comments';
    const pathInternal = '/api/comments';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.comment !== undefined) {
        body = params.comment;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createComment.paramsOrder = [{ type: 'body', paramName: 'comment' }];
/** update comment */ export const updateComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.commentId === undefined) {
        throw new Error('Missing required parameter: commentId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-orders/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    const pathInternal = '/api/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateComment.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** delete comment */ export const deleteComment = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.commentId === undefined) {
        throw new Error('Missing required parameter: commentId');
    }
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    const pathInternal = '/api/comments/{commentId}'.replace('{commentId}', params.commentId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignId !== undefined) {
        urlParams.append('campaignId', params.campaignId.toString());
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteComment.paramsOrder = [{ type: 'parameters' }];
/** Returns list of mail receivers. */ export const getCampaignActivityMailReceivers = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    if (params.isPublic === undefined) {
        throw new Error('Missing required parameter: isPublic');
    }
    const path = '/api/ws-orders/receivers/by-campaign/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/receivers/by-campaign/{campaignId}'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.isPublic !== undefined) {
        urlParams.append('isPublic', params.isPublic.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignActivityMailReceivers.paramsOrder = [{ type: 'parameters' }];
/** Returns batch campaign sub groups */ export const getBatchCampaignSubGroups = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.period === undefined) {
        throw new Error('Missing required parameter: period');
    }
    if (params.page === undefined) {
        throw new Error('Missing required parameter: page');
    }
    if (params.limit === undefined) {
        throw new Error('Missing required parameter: limit');
    }
    const path = '/api/ws-orders/batch/campaign-sub-groups';
    const pathInternal = '/api/batch/campaign-sub-groups';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.period !== undefined) {
        urlParams.append('period', params.period.toString());
    }
    if (params.page !== undefined) {
        urlParams.append('page', params.page.toString());
    }
    if (params.limit !== undefined) {
        urlParams.append('limit', params.limit.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getBatchCampaignSubGroups.paramsOrder = [{ type: 'parameters' }];
export const getCampaignSubGroupById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignSubGroupId === undefined) {
        throw new Error('Missing required parameter: campaignSubGroupId');
    }
    const path = '/api/ws-orders/campaign-sub-group/{campaignSubGroupId}'.replace('{campaignSubGroupId}', params.campaignSubGroupId?.toString());
    const pathInternal = '/api/campaign-sub-group/{campaignSubGroupId}'.replace('{campaignSubGroupId}', params.campaignSubGroupId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignSubGroupById.paramsOrder = [{ type: 'parameters' }];
/** Returns all campaign positions by campaign id. */ export const getAllCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/campaign-positions/all'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/campaign-positions/all'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllCampaignPositions.paramsOrder = [{ type: 'parameters' }];
/** Returns all campaign positions by campaign id. */ export const getCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/campaign-positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/campaign-positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositions.paramsOrder = [{ type: 'parameters' }];
export const processMixedCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignId === undefined) {
        throw new Error('Missing required parameter: campaignId');
    }
    const path = '/api/ws-orders/campaigns/{campaignId}/campaign-positions'.replace('{campaignId}', params.campaignId?.toString());
    const pathInternal = '/api/campaigns/{campaignId}/campaign-positions'.replace('{campaignId}', params.campaignId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
processMixedCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns campaign revenue amountNet4. */ export const getCampaignRevenueAmountNet4 = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.salesPromotionId === undefined) {
        throw new Error('Missing required parameter: salesPromotionId');
    }
    if (params.stages === undefined) {
        throw new Error('Missing required body: stages');
    }
    const path = '/api/ws-orders/campaigns/sales-promotions/{salesPromotionId}/amountNet4'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    const pathInternal = '/api/campaigns/sales-promotions/{salesPromotionId}/amountNet4'.replace('{salesPromotionId}', params.salesPromotionId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.stages !== undefined) {
        body = params.stages;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignRevenueAmountNet4.paramsOrder = [{ type: 'body', paramName: 'stages' }, { type: 'parameters' }];
export * from './types';
export * from './constants';
